import { FreeGameModelBehavior, SlotConstantsBehavior } from "@quest/murka-games-behavior-panther/dist";
// import { GameParserModel } from "../Platform/GameParserModel";
// import { ingenuity } from "@quest/base-core";

export class FreeGameModel extends FreeGameModelBehavior {
  private noWinAnimationSequence: string[] = [];
  private noWinSequenceCounter: number = 0;
  /**
   * Overrided to add the cascade feature in animation sequenece
   * @param serverModel
   */
  constructor(serverModel: any) {
    super(serverModel);
    this.setAnimationSequence(["showCascading", "collectSpecial", "moneyHunting", "clueRevealed", "clueRewardMsgBanner", "clueRewardCollection", "showGrandJP", "fgBigWin", "FGTriggeringAnimation", "retriggeringAnimation", "doNextSpinInFreeGame"]);
    this.setNoWinAnimationSequence(["collectSpecial", "clueRevealed", "sendCloseRequest"]);
  }

  public setNoWinAnimationSequence(data: string[]): void {
    this.noWinAnimationSequence = data;
  }
  public getNoWinAnimationSequence(): string[] {
    return this.noWinAnimationSequence;
  }
  public setNoWinSequenceCounter(data: number): void {
    this.noWinSequenceCounter = data;
  }
  public getNoWinSequenceCounter(): number {
    return this.noWinSequenceCounter;
  }

  public updateNoWinSequenceCounter(): void {
    this.noWinSequenceCounter++;
  }

  public getIsBigWin(winAmount?: number): number {
    return 0;
  }
  public getWinMeterTickUpDurationFg(evt?: number): number {
    if (this.getIsTurboModeOn()) {
      return SlotConstantsBehavior.WINTICKUP_FG_4;
    } else {
      return SlotConstantsBehavior.WINTICKUP_FG_1;
    }
  }
  public getIsFgBigWin(winAmount: any) {
    let win = this.getCurrentWinAmt() 
    // + (ingenuity.parserModel as GameParserModel).getclueRevealedWinAmt() + (ingenuity.parserModel as GameParserModel).getMoneyHuntingTotalWin();
    if (winAmount !== undefined) {
      win = winAmount;
    }
    const currBet = this.serverModel.getCurrentTotalBet();
    if (win > currBet * SlotConstantsBehavior.WINTICKUP_THRESHOLDS[0]) {
      return true;
    }
  }
}
